import { render, staticRenderFns } from "./MultiPolNoHelpList2.vue?vue&type=template&id=3d81d9e8&"
import script from "./MultiPolNoHelpList2.vue?vue&type=script&lang=js&"
export * from "./MultiPolNoHelpList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports